$(document).ready(function () {
window.selected_variant = window.selected_variant || [];
  var minus_pos = 0;
  //       if (window.location.search != '?variant=42846654398616' && window.location.href.indexOf('sneaker-sole-grip-bundles') >= 0) {
  //         minus_pos = 1;
  //       }
  // if (window.location.search != '?variant=45661697573016' && window.location.href.indexOf('sneaker-sole-grip-bundles-discount') >= 0) {
  //         minus_pos = 1;
  //       }
  const params = new URLSearchParams(window.location.search);
          if(window.location.search != '' && window.location.search != undefined && window.location.search != null && window.location.search.indexOf('?') >= 0){          
              if(window.location.search.split('?')[1].replaceAll('\\_', '\_').indexOf("promo") >= 0){
                if(window.location.search.split('?')[1].replaceAll('\\_', '\_').indexOf("promo") >= 0 && sessionStorage.getItem("promo") != ''){
                    console.log(params.get('promo'), window.selected_variant);
                  var promo = params.get('promo') || window.selected_variant[0].promo;
                  sessionStorage.setItem("promo", promo);
                  sessionStorage.setItem("promo_url_for_promo", window.location.href.split('?')[0]);
                }
              } 
          }
  if(window.location.search.indexOf('?') >= 0) {
  if(window.location.search.split('?')[1].indexOf('variant') != -1) {
    sessionStorage.setItem("promo_for_variant", window.location.search.split('?')[1].split('variant=')[1].split('&')[0]);
  }
  }
          if(sessionStorage.getItem("promo") != '' && sessionStorage.getItem("promo_url_for_promo") == (window.location.origin + window.location.pathname) && window.location.search.indexOf('promo') > -1){
            if(document.querySelectorAll('.pdp_image_label').length > 0){
              document.querySelectorAll('.pdp_image_label').forEach(function(val,index){
                  val.innerHTML = sessionStorage.getItem("promo");
              });
            }
          }

  
function click_arrow_on_mobile(image_change =  true, _this = $('.scroll-wrap_mob.main_mob .arrow_pdp.arrow_next'), minus = 0){
  var currentIndex = parseInt($(".scroll-wrap_mob.main_mob #indicator .active").attr("data-index")) - minus;
        var totalItems = $(".scroll-wrap_mob.main_mob .scroll-wrap li:not(.hide_var)").length;
        var targetIndex;
        if (_this.hasClass("arrow_next")) {
            if (currentIndex < totalItems) {
                targetIndex = currentIndex + 1;
                $(".scroll-wrap_mob.main_mob .arrow_prev").show();
            }
        } else {
            if (currentIndex > 1) {
                targetIndex = currentIndex - 1;
            }
        }
        if (typeof targetIndex !== 'undefined') {
            if (targetIndex >= totalItems) {
                $(".scroll-wrap_mob.main_mob .arrow_next").hide();
            } else {
                $(".scroll-wrap_mob.main_mob .arrow_next").show();
            }
           if (targetIndex <= 1) {
              $(".scroll-wrap_mob.main_mob .arrow_prev").hide();
          } else {
              $(".scroll-wrap_mob.main_mob .arrow_prev").show();
          }
          if(image_change == true){
            $(".scroll-wrap_mob.main_mob #indicator li:nth-child(" + targetIndex + ")").click();
          }
        }
}
  
  var carousel = document.querySelector('.main_mob  .scroll-wrap');
var indicator = document.querySelector('.main_mob #indicator');
var elements = document.querySelectorAll('.main_mob .scroll-wrap > li:not(.hide_var)');
var currentIndex = 0;

function scrollIntoViewX(element) {
    if (!element) return;

    const elementRect = element.getBoundingClientRect();
    const parentRect = element.parentNode.getBoundingClientRect();
    const currentScrollLeft = element.parentNode.scrollLeft;

  
  // $(element).closest('ul').height($(element).height());
  // $(element).closest('.after_on_load').find(".arrow_pdp").css("top",($(element).height()/2)+"px");
  // setTimeout(function(){
  //   $(element).closest('ul').height($(element).height());
  //   $(element).closest('.after_on_load').find(".arrow_pdp").css("top",($(element).height()/2)+"px");
  // },200);

    if (elementRect.left < parentRect.left) {
        element.parentNode.scrollLeft = currentScrollLeft - (parentRect.left - elementRect.left);
    }
    else if (elementRect.right > parentRect.right) {
        element.parentNode.scrollLeft = currentScrollLeft + (elementRect.right - parentRect.right);
    }
    var visibleItem = element;
              var imgHeight = $(visibleItem).find('img').height() || $(visibleItem).find('video').height();
              var imgWidth = $(visibleItem).find('img').width() || $(visibleItem).find('video').width();

              var containerWidth = visibleItem.offsetWidth;
              var newHeight = (imgHeight / imgWidth) * containerWidth;

              console.log(imgHeight, "scroll");
                document.querySelector(".scroll-wrap_mob .scroll-wrap").style.height = `${imgHeight}px`;
                if (imgHeight > 100) {
                  document.querySelector(".scroll-wrap_mob .scroll-wrap").style.minHeight = 'unset';
                }
}  
  
function renderIndicator(elements = elements) {
  indicator.innerHTML = '';
  console.log(elements.length);
  for (var i = 0; i < elements.length; i++) {
    var button = document.createElement('li');
    
    button.innerHTML = (i === currentIndex ? `<span class='active' data-index='${i+1}'></span>` : `<span data-index='${i+1}'></span>`);
    (function(i) {
      button.onclick = function() {
        scrollIntoViewX(elements[i]);
      }
    })(i);
    indicator.appendChild(button);
  }
}

function all_observes(elements = document.querySelectorAll('.main_mob .scroll-wrap > li:not(.hide_var)')){
  var observer = new IntersectionObserver(function(entries, observer) {
    var activated = entries.reduce(function (max, entry) {
      return (entry.intersectionRatio > max.intersectionRatio) ? entry : max;
    });
    if (activated.intersectionRatio > 0) {
      currentIndex = elementIndices[activated.target.getAttribute("id")];
      renderIndicator(document.querySelectorAll('.main_mob .scroll-wrap > li:not(.hide_var)'));
    }
  }, {
    root:carousel, threshold:0.5
  });
  var elementIndices = {};
  for (var i = 0; i < elements.length; i++) {
    console.log(elements[i].getAttribute("id"));
    elementIndices[elements[i].getAttribute("id")] = i;
    observer.observe(elements[i]);
  }
}

all_observes(document.querySelectorAll('.main_mob .scroll-wrap > li:not(.hide_var)'));

  var scroll_wrp_l = document.querySelector(".scroll-wrap_mob .scroll-wrap"), o;
  if (scroll_wrp_l) {
      scroll_wrp_l.addEventListener("scroll", function () {
          clearTimeout(o);
          o = setTimeout(function () {
              var activeElement = document.querySelector(".scroll-wrap_mob.main_mob #indicator .active").parentElement;
              var currentIndex = Array.from(activeElement.parentElement.children).indexOf(activeElement) + 1;
              var totalItems = document.querySelectorAll(".scroll-wrap_mob.main_mob .scroll-wrap li:not(.hide_var)").length;
              var nextArrow = document.querySelector(".scroll-wrap_mob.main_mob .arrow_next");
              var prevArrow = document.querySelector(".scroll-wrap_mob.main_mob .arrow_prev");
  
              nextArrow.style.display = "block";
              prevArrow.style.display = "block";
  
              if (currentIndex >= totalItems) {
                  nextArrow.style.display = "none";
              }
  
              if (currentIndex < 2) {
                  prevArrow.style.display = "none";
              }
            $('.media-video').each(function(index, val) {
              var v = $(val)[0];
              $(val).closest('.custom_video').find('.product_media_button').show();
              if(v != null){
                if (!v.paused) {
                  v.pause();
                  v.controls=false;
                  v.loop=true;
                  v.autoplay=false;
                  v.muted=true;
                  v.currentTime=0;
                }
              }
            });
            var video = elements[currentIndex-1].querySelector('video');
            $(elements[currentIndex-1]).find('.product_media_button').show();
              if(video != null){
                  video.pause();
                  video.controls=false;
                  video.autoplay=false;
                  video.currentTime=0;
                  // video.play(); 
              }

            // if($(elements[currentIndex-1]).attr("data-v_mob_id") != undefined && $(elements[currentIndex-1]).attr("data-v_mob_id") != '' && $(elements[currentIndex-1]).attr("data-v_mob_id") != null && $(elements[currentIndex-1]).attr("data-change") != null && $(elements[currentIndex-1]).attr("data-change") != undefined){
            //   variant_image_change($(elements[currentIndex-1]).attr("data-v_mob_id"));
            // }
            console.log(currentIndex);

            var visibleItem = document.querySelectorAll('.main_mob .scroll-wrap > li:not(.hide_var)')[currentIndex - 1];
              var imgHeight = $(visibleItem).find('img').height() || $(visibleItem).find('video').height();
              var imgWidth = $(visibleItem).find('img').width() || $(visibleItem).find('video').width();

              var containerWidth = visibleItem.offsetWidth;
              var newHeight = (imgHeight / imgWidth) * containerWidth;

              console.log(imgHeight);
                scroll_wrp_l.style.height = `${imgHeight}px`;
                if (imgHeight > 100) {
                  scroll_wrp_l.style.minHeight = 'unset';
                }
            

          }, 50);
      });
  }

 
//   function image_height() {
//  var visibleItem = $('.scroll-wrap li');
//     var imgHeight = $(visibleItem).find('img').height() || $(visibleItem).find('video').height();
//     var imgWidth = $(visibleItem).find('img').width() || $(visibleItem).find('video').width();

//     var containerWidth = visibleItem.offsetWidth; 
//     var newHeight = (imgHeight / imgWidth) * containerWidth;

//       $('.scroll-wrap').css('height',`${imgHeight}px`);
//       if (imgHeight > 100) {
//         $('.scroll-wrap').css('minHeight','unset');
//       }
//   } 

function append_image_video(el_div) {
   console.log(el_div, el_div.querySelector('[data_append_img_video]'), "  sssssss");
   if(el_div.querySelector('[data_append_img_video]') != null) {
    var el = el_div.querySelector('[data_append_img_video]');
    var type = el.dataset.type;
    var src = el.dataset.src;
    var alt = el.dataset.alt || "";
    var mediaId = el.dataset.media_id || "";
    var preview_image = el.dataset.preview_image || "";
    var class_name = el.dataset.class || "";
    var zoomImg = el.dataset.zoomimg || "";
    var zoom_data = zoomImg == 'data-image-zoom' ? 'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-sizes="auto"' : '';
    var width = el.dataset.width || '';
    width = width != '' ? `width = ${width}` : '';

    if (type === "image") {
      el.innerHTML = `
        <img
          class="${class_name}"
          src="${src}"
          alt="${alt}"
          ${zoomImg}
          data-src="${src}"
          ${zoom_data}
          ${width}
        >`;
    }

    if (type === "video") {
      el.innerHTML = `
        <video
          class="media-video product-single__thumbnail-image"
          id="${mediaId}"
          loop
          muted
          playsinline
          poster="${preview_image}"
          style="background: url(${preview_image}) center/cover no-repeat;"
          >
          <source src="${src}" type="video/mp4">
            <img src="${preview_image}" alt="Preview Image" />
        </video>
        ${el.innerHTML}  
      `;
    }

    el_div.classList.add("media-appended");
  }
}

function appendMedia(variant_id = document.querySelector('.product-template__container.product_temp').getAttribute("data-selected_variant_id")) {
  document.querySelectorAll(`.var_videos.var_video_${variant_id}:not(.media-appended):not(.product-single__thumbnails-item-slide)`).forEach(function(el_div) {
   append_image_video(el_div);
  });
  document.querySelectorAll(`.custom_video:not(.media-appended):not(.var_videos):not(.product-single__thumbnails-item-slide)`).forEach(function(el_div) {
    append_image_video(el_div);
  });
}


  function image_height() {
    var visibleItem = $('.scroll-wrap li');
    var imgHeight = $(visibleItem).find('.learnmore_video').height() || $(visibleItem).find('img').height() || $(visibleItem).find('video').height();
    
    var visibleItem_data = $('.scroll-wrap li:visible').first();
    if (!visibleItem_data.length) return;
    if (visibleItem_data.data('height-set')) return;
    visibleItem_data.data('height-set', true);
    var firstMedia = $(visibleItem_data).find('.learnmore_video, video, img')[0];
    if (!firstMedia) return;

    function setHeight(width, height, parent_div) {
      var ph = parent_div.parent().outerHeight();
        if (width > 0 && height > 0 && ph > 0) {
            // alert("video: " + height + " - parent: " + ph);
            parent_div.closest(".product_loader_wrp").find('.product_loader').remove();
            $('.scroll-wrap').css('height',`${ph}px`);
            if (ph > 100) {
              $('.scroll-wrap').css('minHeight','unset');
            }
        }
    }

    if (firstMedia.tagName.toLowerCase() === 'video' || firstMedia.classList.contains('learnmore_video')) {
        if (firstMedia.videoHeight > 0 && firstMedia.videoWidth > 0) {
            setHeight(firstMedia.videoWidth, firstMedia.videoHeight, $(firstMedia));
        } else {
            firstMedia.addEventListener('canplay', function() {
                setTimeout(function() {
                    setHeight(firstMedia.videoWidth, firstMedia.videoHeight, $(firstMedia));
                }, 30); // small delay instead of alert
            }, { once: true });
        }
    } else if (firstMedia.tagName.toLowerCase() === 'img') {
        if (firstMedia.naturalHeight > 0 && firstMedia.naturalWidth > 0) {
            setHeight(firstMedia.naturalWidth, firstMedia.naturalHeight, $(firstMedia));
        } else {
            firstMedia.addEventListener('load', function() {
                setHeight(firstMedia.naturalWidth, firstMedia.naturalHeight, $(firstMedia));
            }, { once: true });
        }
    }else{
      // alert(imgHeight);
      $(firstMedia).closest(".product_loader_wrp").find('.product_loader').remove();
      $('.scroll-wrap').css('height',`${imgHeight}px`);
      if (imgHeight > 100) {
        $('.scroll-wrap').css('minHeight','unset');
      }
    }
  }
  
  image_height();
  setTimeout(function(){
    image_height();
  },1000);

      $('body').on("click",".product-media-main-wrp .arrow_pdp",function(){
        var activeThumb = $(".product-single__thumbnails .active-thumb");
        if ($(this).hasClass("arrow_next_m")) {
          activeThumb.closest('li').nextAll('li:not(.hide_not_var)').first().find('.product-single__thumbnail').click();
        } else {
          activeThumb.closest('li').prevAll('li:not(.hide_not_var)').first().find('.product-single__thumbnail').click();
        }
    });

    $('body').on("click",".product-single__thumbnails-item .product-single__thumbnail",function(event){
      event.preventDefault();
      $('.product-single__thumbnail').removeClass("active-thumb");
      $(this).addClass("active-thumb");
      var index = parseInt($(this).parent().attr("data-slider-slide-index"));
      $('.product-single__media-wrapper').addClass("hide");
      $('.product-single__media-wrapper[data-index="'+index+'"]:not(.hide_not_var)').removeClass("hide");
      $('.media-video').each(function(index, val) {
        var v = $(val)[0];
        $(val).closest('.custom_video').find('.product_media_button').show();
        if(v != null){
            v.pause();
            v.controls=false;
            v.loop=true;
            v.autoplay=false;
            v.muted=true;
            v.currentTime=0;
        }
      });
      if($('.product-single__media-wrapper[data-index="'+index+'"][data-product-media-type-video]').length == 1){
        var video = $('.product-single__media-wrapper[data-index="'+index+'"][data-product-media-type-video]').find('video')[0];
        $('.product-single__media-wrapper[data-index="'+index+'"][data-product-media-type-video]').find('.product_media_button').show();
        if(video != null){
            video.pause();
            video.controls=false;
            video.autoplay=false;
            video.currentTime=0;
            // video.play(); 
        }
      }
      var total_length = $('.product-single__thumbnails-item:not(.hide_not_var)').length;
      console.log(total_length, index);
      $('.product-media-main-wrp .arrow_pdp.arrow_prev_m').show();
      $('.product-media-main-wrp .arrow_pdp.arrow_next_m').show();
      if(index ==  0){
        $('.product-media-main-wrp .arrow_pdp.arrow_prev_m').hide();
      } else if(index == total_length){
        $('.product-media-main-wrp .arrow_pdp.arrow_next_m').hide();
      }

      // if($(this).attr("data-v_id") != 'undefined' && $(this).attr("data-v_id") !== undefined && $(this).attr("data-v_id") != null && $(this).attr("data-v_id") != ''){
      //   variant_image_change($(this).attr("data-v_id"));  
      // }
      
    });
  
    var ct = 0;
    function mobile_image_load() {
      if($('.main_mob #indicator li').length > 0){
        var pos = $('#after_on_load [data-v_mob_id="'+$('.product-single__thumbnails').attr('data-selected_varaint')+'"]').attr("data-indi_index");        
        if($('.main_mob #indicator').length > 0){
          
          
          if($('.main_mob #indicator li span[data-index="'+pos+'"]').length > 0){
            $('.main_mob #indicator li span[data-index="'+pos+'"]').closest('li').click();
          }
        }
        setTimeout(function() {
          if($('#only_for_load').length > 0){
            $('#after_on_load').css({'height':'auto','margin-bottom':'24px','opacity':'1'});
            $('#after_on_load .scroll-wrap').css('height',$('#after_on_load').find('.scroll-wrap').find('li:first-child').outerHeight()+'px');
            $('#only_for_load').remove();
          }  
        },500);
        
      } else{
        ct += 1;
        if(ct <= 30){
          setTimeout(function() {
            mobile_image_load();
          },100);
        }
      }
    }
    mobile_image_load();
  
    function load_change(){
      console.log($('.product-single__thumbnails').attr('data-selected_varaint'));
      if($('.product-single__thumbnails [data-v_id="'+$('.product-single__thumbnails').attr('data-selected_varaint')+'"]').length > 0){
        change_image_function = true;
        $('.product-single__thumbnails [data-v_id="'+$('.product-single__thumbnails').attr('data-selected_varaint')+'"]').click();
      }
    }
    // $(window).on("load",function(){
    //   load_change();
    // });
  
    // $(window).on("resize",function(){
    //   var pos = $('#after_on_load [data-v_mob_id="'+$('.product-single__thumbnails').attr('data-selected_varaint')+'"]').attr("data-indi_index");        
    //      if($('.main_mob #indicator li span[data-index="'+pos+'"]').length > 0){
    //         $('.main_mob #indicator li span[data-index="'+pos+'"]').closest('li').click();
    //       }
    //     setTimeout(function() {
    //         $('#after_on_load').css({'height':'auto','margin-bottom':'24px','opacity':'1'});
    //         $('#after_on_load .scroll-wrap').css('height',$('#after_on_load').find('.scroll-wrap').find('li:first-child').outerHeight()+'px');
    //     },500);
    // });

    const intervalID = setInterval(imagechange, 10);
    var timesRun = 0;
    var imagechange = setInterval(function () {
        timesRun += 1;
        if (timesRun === 10) {
            clearInterval(imagechange);
        }
        var img = document.querySelector("img.product-single__thumbnail-image:not(.with_video)"),
            height = img ? img.parentNode.clientHeight + "px" : "100%",
            videoImages = document.querySelectorAll(".with_video.product-single__thumbnail-image");
        videoImages.length > 0 &&
            videoImages.forEach(function (e) {
                e.style.height = height;
            });
             document.querySelectorAll("[data-slider-item] img").forEach(function(e){
              e.style.height = height;
            });
    }, 10);
    
    if( $(".similar_products").length > 0 ){
      var simlar_settings = {
            infinite: !1,
            slidesToShow: 4.5,
            slidesToScroll: 1,
            arrows: !0,
            draggable: true,
            speed: 100,
            swipeToSlide: true,
            waitForAnimate: false,
            touchThreshold: 100,
            // prevArrow: $(".custom_slider_btn .arrow_prev"),
            // nextArrow: $(".custom_slider_btn .arrow_next"),
            responsive: [{ breakpoint: 900, settings: "unslick" }],
        };
        $(".similar_products").slick(simlar_settings);
    }

    $("body").on("click", ".scroll-wrap_mob.main_mob .arrow_pdp", function () {
        click_arrow_on_mobile(true, $(this));
    });

    function formatMoney(e, t) {
        "string" == typeof e && (e = e.replace(".", ""));
        var i = "",
            s = /\{\{\s*(\w+)\s*\}\}/,
            n = t || "${{amount}}";
        function r(e, t, i, s) {
            if (((i = i || ","), (s = s || "."), isNaN(e) || null === e)) return 0;
            var n = (e = (e / 100).toFixed(t)).split(".");
            return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? s + n[1] : "");
        }
        switch (n.match(s)[1]) {
            case "amount":
                i = r(e, 2);
                break;
            case "amount_no_decimals":
                i = r(e, 0);
                break;
            case "amount_with_comma_separator":
                i = r(e, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                i = r(e, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                i = r(e, 0, " ");
                break;
            case "amount_with_apostrophe_separator":
                i = r(e, 2, "'");
        }
        return n.replace(s, i);
    }
    var pdp_json = JSON.parse($('#ProductJson').html());
    var ProdcutMetafields = JSON.parse($('#ProdcutMetafields').html());
    var moneyFormat = $('body').attr('data-moneyFormat'), change_image_function = false;

    function variant_image_change(v_id){
      var variant = pdp_json['variants'].find((val) => val.id == v_id);
      
      $.each(variant.options,function(index, val){
        change_image_function = true;
        console.log("Ddd");
        $("[data-id='SingleOptionSelector-"+index+"']").find('.select-dropdown__list-item[data-value="'+val+'"]').click();
      });
    }
  
    function change_name_id(){
      var pdp_variants = pdp_json['variants'];
      var option_values = [];
      $('.select-dropdown__button').each(function(index, val) {
        option_values.push($('.select-dropdown__button_'+index).attr("data-value"));
      });
      option_values = option_values.join(' / ');

      var variant = pdp_variants.find((val) => val.public_title == option_values);
      var variant_product_id = $('.product_temp').attr("data-product_id");

      if (variant != null && variant != undefined){
      
      $('.product-single').find('.product-form__variants[name="id"]').val(variant.id);
      $('.product-single').find('.product_subtitle').html(ProdcutMetafields.pdp_subtitle[variant.id]);
      $('.product-single').find('.js_pdp_desc').html(ProdcutMetafields.js_pdp_desc[variant.id]);

      if($('div[data-changeURL=true]').length > 0){  
        var window_url = new URL(window.location);
        window_url.searchParams.set("variant", variant.id);
        history.replaceState(null, "", window_url.toString());
      }
      
      if(variant.available == false){
        $('.product-single').find('button.product-form__cart-submit').attr("aria-disabled","true");
        $('.product-single').find('button.product-form__cart-submit').attr("aria-label","Sold out");
        $('.product-single').find('button.product-form__cart-submit').find('[data-add-to-cart-text]').html(window.sold_out_text);
        $('.instock_animate').hide();
      } else{
        $('.product-single').find('button.product-form__cart-submit').removeAttr("aria-disabled");
        $('.product-single').find('button.product-form__cart-submit').attr("aria-label","Add to cart");
        $('.product-single').find('button.product-form__cart-submit').find('[data-add-to-cart-text]').html(window.addtocart_text);
        $('.instock_animate').show();
      }

       if($('.var_videos').length > 0) {
        $('.var_videos').each(function(it, vd){
          $(vd).addClass("hide_var");
          $(vd).addClass("hide_not_var");
          if ($(vd).hasClass(`var_video_${variant.id}`)) {
            $(vd).removeClass("hide_var");
            $(`.var_video_${variant.id}`).removeClass("hide_not_var");
          } 
        });
      }  
      
      if(variant.featured_media != undefined && variant.featured_media != 'undefined' && variant.featured_media != null){
        var pos =variant.featured_media.position - 1;
        if (minus_pos == 1){
          pos = pos - 1;
          console.log(pos);
        }
        console.log(minus_pos, " minus_pos");
        
        var image_src = variant.featured_media.preview_image.src;
        if($('.main_image_for_change:not(.mobile_image_change)').length > 0) {
          $('.main_image_for_change:not(.mobile_image_change)').attr("src",image_src.replace(/\.(?=[^.]*$)/,'_800x800.'));
          $('.main_image_for_change.thumbnail_image_change:not(.mobile_image_change)').attr("data-src",image_src.replace(/\.(?=[^.]*$)/,'_110x100@2x.'));
          
          let aspectRatio = $('.main_image_for_change:not(.mobile_image_change)').width() / $('.main_image_for_change:not(.mobile_image_change)').height(); 
          let paddingTop = (1 / aspectRatio) * 100;    
          $('.main_image_for_change:not(.mobile_image_change)').parent('.product-single__media').css('padding-top',`${paddingTop}%`);
        }
        if($('.main_image_for_change.mobile_image_change').length > 0) {
          $('.main_image_for_change.mobile_image_change').attr("src",image_src.replace(/\.(?=[^.]*$)/,'_540x540@2x.'));
        }
      }

      appendMedia(variant.id);
      
      $('.zoom').trigger('zoom.destroy');
      $('.zoom').zoom();
      
      if(variant.featured_media != undefined && variant.featured_media != 'undefined' && variant.featured_media != null){
        $('#indicator li').find('span[data-index="1"]').closest('li').click();    
        $('.product-single__thumbnails-item[data-slider-slide-index="'+$('.product-single__thumbnails-item:first').attr("data-slider-slide-index")+'"]').find('.product-single__thumbnail').click();
      }
     
      
      renderIndicator(document.querySelectorAll('.main_mob .scroll-wrap > li:not(.hide_var)'));
      all_observes(document.querySelectorAll('.main_mob .scroll-wrap > li:not(.hide_var)'));
      var scroll_wrp_l = document.querySelector(".scroll-wrap_mob .scroll-wrap");
      // scroll_wrp_l.dispatchEvent(new Event("scroll"));
      image_height();

      
       const intervalID = setInterval(imagechange, 10);
    var timesRun = 0;
    var imagechange = setInterval(function () {
        timesRun += 1;
        if (timesRun === 10) {
            clearInterval(imagechange);
        }
        var img = document.querySelector("img.product-single__thumbnail-image:not(.with_video)"),
            height = img ? img.parentNode.clientHeight + "px" : "100%",
            videoImages = document.querySelectorAll(".with_video.product-single__thumbnail-image");
        videoImages.length > 0 &&
            videoImages.forEach(function (e) {
                e.style.height = height;
            });
            document.querySelectorAll("[data-slider-item] img").forEach(function(e){
              e.style.height = height;
            });
    }, 10);

      if(variant.compare_at_price != null && $('.product-single').find('.price').length > 0){
        $('.product-single').find('.price').addClass("price--on-sale");
        $('.product-single__meta').find('.price__sale').show();
        $('.product-single__meta').find('.price__regular').hide();
        $('.product-single__meta').find('.price__sale span[data-sale-price]').html(formatMoney(variant.price, moneyFormat));
        $('.product-single__meta').find('.price__sale').find('s[data-regular-price]').html(formatMoney(variant.compare_at_price, moneyFormat)); 
      } else {
        $('.product-single').find('.price').removeClass("price--on-sale");
        $('.product-single__meta').find('.price__regular').show();
        $('.product-single__meta').find('.price__sale').hide();
        $('.product-single__meta').find('.price__regular').find('span[data-regular-price]').html(formatMoney(variant.price, moneyFormat));
      }
        
      if(variant.compare_at_price != null && $('.addtocart_price').find('.price_var').length > 0){
        $('.addtocart_price').find('.price_var').html(formatMoney(variant.price, moneyFormat));
        $('.addtocart_price').find('.cross_price').html(formatMoney(variant.compare_at_price, moneyFormat)); 
        $('.addtocart_price').find('.cross_price').removeClass("hide");
        $('.addtocart_price').find('.cross_price').removeClass("show").attr("data-price",variant.compare_at_price / 100);
        $('.addtocart_price').find('.price_var').removeClass("show").attr("data-price",variant.price / 100);
        if (Shopify.currency.active == 'HUF'){
          $('.addtocart_price').find('.cross_price')
  .removeClass("show")
  .attr("data-price", (variant.compare_at_price/100).toString().slice(0,-3) + '.' + (variant.compare_at_price/100).toString().slice(-3));

$('.addtocart_price').find('.price_var')
  .removeClass("show")
  .attr("data-price", (variant.price/100).toString().slice(0,-3) + '.' + (variant.price/100).toString().slice(-3));


        }
        if (Shopify.currency.active == 'RUB'){
          $('.addtocart_price').find('.cross_price').removeClass("show").attr("data-price",formatMoney(variant.compare_at_price, moneyFormat).replace(',00','').replace('руб').replace('undefined',''));
          $('.addtocart_price').find('.price_var').removeClass("show").attr("data-price",formatMoney(variant.price, moneyFormat).replace(',00','').replace('руб').replace('undefined',''));
        }
      } else if($('.addtocart_price').find('.price_var').length > 0) {
        $('.addtocart_price').find('.price_var').html(formatMoney(variant.price, moneyFormat));
        $('.addtocart_price').find('.cross_price').addClass("hide");
        $('.addtocart_price').find('.price_var').removeClass("show").attr("data-price",variant.price / 100);
        $('.addtocart_price').find('.cross_price').removeClass("show").attr("data-price",variant.compare_at_price / 100);
          if (Shopify.currency.active == 'HUF'){
         $('.addtocart_price').find('.cross_price')
  .removeClass("show")
  .attr("data-price", (variant.compare_at_price/100).toString().slice(0,-3) + '.' + (variant.compare_at_price/100).toString().slice(-3));

$('.addtocart_price').find('.price_var')
  .removeClass("show")
  .attr("data-price", (variant.price/100).toString().slice(0,-3) + '.' + (variant.price/100).toString().slice(-3));

        }
        if (Shopify.currency.active == 'RUB'){
          $('.addtocart_price').find('.cross_price').removeClass("show").attr("data-price",formatMoney(variant.compare_at_price, moneyFormat).replace(',00','').replace('руб').replace('undefined',''));
          $('.addtocart_price').find('.price_var').removeClass("show").attr("data-price",formatMoney(variant.price, moneyFormat).replace(',00','').replace('руб').replace('undefined',''));
        }
      }  

      if($('.afterpay_integrate').length > 0) {
        if ($('.afterpay_integrate').find('square-placement').length > 0){
          $('.afterpay_integrate').find('square-placement').attr("data-item-skus",variant.sku);
          $('.afterpay_integrate').find('square-placement').attr("data-amount",variant.price / 100);
        }
      }  

   console.log(variant, pdp_json.handle);

      if(change_image_function == true){
        change_image_function = false;
      }
      
       $.get('/products/'+pdp_json.handle+'?variant='+variant.id,function(data){
         if( $(".similar_products").length > 0 ){
            $('#similar_products').html($(data).find('#similar_products').html());
             $(".similar_products").slick(simlar_settings);
         }
      });

       

        console.log(pdp_json);
        $('.pdp_image_label').show();
        if($('.pdp_image_label').find('.dsicount_text_badge').length > 0 && variant.compare_at_price != null){
          var dis = parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          $('.dsicount_text_badge').text(dis);
        } else if(variant.compare_at_price != null && $('.pdp_image_label').attr("data-back_to_school") != undefined) {
          var dis = parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          var discount_text = $('.pdp_image_label').attr("data-back_to_school").replace('#discount#', '<span class="dsicount_text_badge">'+dis+'</span>');
          $('.pdp_image_label').html(discount_text);
        } else if(pdp_json.tags.includes('best_seller')) {
          $('.pdp_image_label').text($('.pdp_image_label').attr("data-label_other"));
        } else {
          $('.pdp_image_label').hide();
        }
        var find_badge = ProdcutMetafields.badge_metafields[variant.id];
         console.log(find_badge);
        if(find_badge != '' && find_badge != undefined && find_badge != null && find_badge != ' ') {
          if(document.querySelectorAll('.pdp_image_label').length > 0){
              document.querySelectorAll('.pdp_image_label').forEach(function(val,index){
                  val.innerHTML = find_badge;
              });
            } 
        }
        else {
         if(window.selected_variant != '' && window.selected_variant != undefined && window.location.search.indexOf('promo') > -1){
          var find_i = window.selected_variant.findIndex((x)=> Number(x.id) == Number(variant.id));
          if(document.querySelectorAll('.pdp_image_label').length > 0){
              document.querySelectorAll('.pdp_image_label').forEach(function(val,index){
                if(window.selected_variant[find_i] != undefined) {
                  val.innerHTML = window.selected_variant[find_i].promo;
                }
              });
            }
        }
        if(variant.id == sessionStorage.getItem("promo_for_variant")) {
          var find_i = window.selected_variant.findIndex((x)=> Number(x.id) == Number(variant.id));
          if(window.location.search != '' && window.location.search != undefined && window.location.search != null && window.location.search.indexOf('?') >= 0){          
              if(window.location.search.split('?')[1].replaceAll('\\_', '\_').indexOf("promo") >= 0){
                if(window.location.search.split('?')[1].replaceAll('\\_', '\_').indexOf("promo") >= 0 && sessionStorage.getItem("promo") != ''){
                  var promo = params.get('promo') || window.selected_variant[find_i].promo;
                  sessionStorage.setItem("promo", promo);
                  sessionStorage.setItem("promo_url_for_promo", window.location.href.split('?')[0]);
                }
              } 
          }
          if(sessionStorage.getItem("promo") != '' && sessionStorage.getItem("promo_url_for_promo") == (window.location.origin + window.location.pathname)   && window.location.search.indexOf('promo') > -1){
            if(document.querySelectorAll('.pdp_image_label').length > 0){
              document.querySelectorAll('.pdp_image_label').forEach(function(val,index){
                  val.innerHTML = sessionStorage.getItem("promo");
              });
            }
          }
        } else if(window.location.search != '' && window.location.search != undefined && window.location.search != null) {
           if(window.location.search.split('?')[1].indexOf('variant') == -1 && window.location.search.indexOf('?') >= 0){
          if(window.location.search != '' && window.location.search != undefined && window.location.search != null){          
              if(window.location.search.split('?')[1].replaceAll('\\_', '\_').indexOf("promo") >= 0){
                if(window.location.search.split('?')[1].replaceAll('\\_', '\_').indexOf("promo") >= 0 && sessionStorage.getItem("promo") != ''){
                  var promo = params.get('promo') || window.selected_variant[find_i].promo;
                  sessionStorage.setItem("promo", promo);
                  sessionStorage.setItem("promo_url_for_promo", window.location.href.split('?')[0]);
                }
              } 
          }
          if(sessionStorage.getItem("promo") != '' && sessionStorage.getItem("promo_url_for_promo") == (window.location.origin + window.location.pathname)   && window.location.search.indexOf('promo') > -1){
            if(document.querySelectorAll('.pdp_image_label').length > 0){
              document.querySelectorAll('.pdp_image_label').forEach(function(val,index){
                  val.innerHTML = sessionStorage.getItem("promo");
              });
            }
          }}
      } 
      }
    }
    }

  change_name_id();
  
    $('body').on("click",".select-dropdown__button", function(e) {
      $(this).closest('.select-dropdown').find(".select-dropdown__list").toggleClass("active");
    });
    
    $('body').on("click",".select-dropdown__list-item", function(e) {
      var _this = $(this);
      var value = _this.attr("data-value");
      $('.select-dropdown__list-item').removeClass("active");
      _this.addClass("active");

      var s_change = _this.closest('.select-dropdown').find(".select-dropdown__button span.on_change");
      s_change.html(_this.html());
      _this.closest('.select-dropdown').find(".select-dropdown__button").attr("data-value", value); 
      $(".select-dropdown__list").removeClass("active");

      if ($(".product-single__title").attr("data-variant_change") === "true") {
          $(".product-single__title").text($(".select-dropdown").find(".above_title").attr("data-above_title"));
      }
      change_name_id();
    });

    $('body').on("click",".product_media_button", function(e) {
      $(this).hide();
       var video = $(this).closest('.custom_video').find('video')[0];
      if(video != null){
          video.pause();
          video.controls=false;
          video.loop=true;
          video.autoplay=false;
          video.muted=true;
          video.currentTime=0;
          video.play(); 
      }
    });
    
     document.querySelectorAll('body .select_drop_down_redirect').forEach(function(element) {
          element.addEventListener('click', function(e) {
              e.preventDefault();
              if (element.getAttribute("data-value") === 'EDGE® Grip Spray - 2oz') {
                  window.location.href = '/products/sneaker-sole-grip-spray?variant=42379657150616';
              } else if (element.getAttribute("data-value") === 'EDGE® Grip Spray - 4oz') {
                  window.location.href = '/products/sneaker-sole-grip-spray-4oz?variant=42835939917976';
              }
          });
      });

  
});